<template>
    <tr class="w-full">
        <td> <!--
            <label class="flex justify-start mt-1 cursor-pointer">
                <span class="">
                    <input class="checkbox" :checked="checked" @click="$emit('selectTeam')" type="checkbox">
                    <span class="checkbox-custom"></span>
                </span>
            </label>
            -->
            <div class="rounded-full h-2 w-2 mx-auto"
                :class="team.deleted_at ? 'bg-brand-yellow': 'bg-white'">
            </div>
        </td>
        <td class="w-8">
            {{teamCount}}
        </td>
        <td @mousedown="overflowTumbler" @mouseup="overflowTumbler" @mouseout="endOverflow" class="max-w-2xxs  pl-2 truncate whitespace-no-wrap" field="canAbs"
            >
                <span :class="isSearched('name')? 'bg-brand-pink-light':''">{{team.name}}</span>

        </td>
        <td @mousedown="overflowTumbler" @mouseup="overflowTumbler" @mouseout="endOverflow" class="max-w-2xxs truncate pr-10 whitespace-no-wrap"  field="canAbs">
            <span :class="isSearched('captain.name')? 'bg-brand-pink-light':''">{{team.captain.name}}</span>
        </td>
        <td class="max-w-2xxs pr-8 whitespace-no-wrap">
            <span :class="isSearched('captain.phone')? 'bg-brand-pink-light':''">{{team.captain.phone}}</span>
        </td>
        <td @mousedown="overflowTumbler" @mouseup="overflowTumbler" @mouseout="endOverflow" class="whitespace-no-wrap" field="canAbs">
            <span :class="isSearched('captain.email')? 'bg-brand-pink-light':''">{{team.captain.email}}</span>
        </td>
        <td>
            {{team.play_count || 0}}
        </td>
        <!--<portal :to="`replace-question-${question.id}`">-->
        <!--<get-new-question :question-id="question.id" @replaced="$emit('replaced')"></get-new-question>-->
        <!--</portal>-->
    </tr>
</template>

<script>
export default {
  name: 'data-base-line',
  props: ['team', 'teamCount', 'checked'],
  mounted() {
    // тут проходим по всей строке и выставляем поинтеры
    const elem = this.$el;
    [...elem.children].forEach((element) => {
      if ((element.scrollWidth > element.clientWidth) && element.getAttribute('field') === 'canAbs') {
        element.classList.toggle('cursor-pointer');
      }
    });
  },


  methods: {

    overflowTumbler(event) {
      const target = event.target.parentElement;
      const isOverflow = target.scrollWidth > target.clientWidth;
      if (target.getAttribute('field') === 'canAbs' && (isOverflow || target.classList.contains('exp'))) {
        if ((event.type === 'mouseup') && isOverflow) return;
        target.classList.toggle('truncate');
        target.classList.toggle('absolute');
        target.classList.toggle('border');
        target.classList.toggle('bg-white');
        target.classList.toggle('fit_content');
        target.classList.toggle('exp');
      }
    },

    endOverflow(event) {
      const target = event.target.parentElement;
      const isOverflow = target.scrollWidth > target.clientWidth;
      if (target.getAttribute('field') === 'canAbs' && (target.classList.contains('exp'))) {
        target.classList.toggle('truncate');
        target.classList.toggle('absolute');
        target.classList.toggle('border');
        target.classList.toggle('bg-white');
        target.classList.toggle('fit_content');
        target.classList.toggle('exp');
      }
    },

    isSearched(field) {
      if (!this.$route.query.like) return false;
      const fieldNamesArray = field.split('.');
      const rootObj = this.team;
      const lastObj = fieldNamesArray.reduce((acc, field) => acc[field], rootObj);
      console.dir(lastObj);
      if (!lastObj) return false;

      return !!lastObj.toLowerCase().includes(this.$route.query.like.toLowerCase());
    },


  },
};
</script>

<style scoped>

    .checkbox {
        display: none;
    }

    .checkbox-custom {
        position: relative;
        width: 24px;
        height: 24px;
        border: 2px solid #ccc;
        border-radius: 3px;

    }

    .checkbox-custom,
    .label {
        display: inline-block;
        vertical-align: middle;
    }

    .checkbox:checked + .checkbox-custom::before {
        content: "";
        display: block;
        position: absolute;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        background-color: #bd006c;
        border-radius: 2px;
        outline: 2px solid #979797;
        border: 2px solid white;
    }

    td {
        @apply text-left p-2 pl-0 font-sans text-sm;
    }

    .fit_content {
      max-width: fit-content !important;
    }
</style>
